import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import _ from 'lodash';
import SmartUrlActions from './smart-url-actions';

const initialState = Immutable({ byId: {} });

const reducer = createReducer(on => {
  on(SmartUrlActions.fetchSmartUrlsSuccess, (state, { smartUrls }) => {
    const byId = _.reduce(
      smartUrls,
      (acc, smartUrl) => {
        acc[smartUrl.id] = smartUrl;
        return acc;
      },
      {}
    );
    return state.set('byId', byId);
  });
  on(SmartUrlActions.add, (state, { smartUrls }) => {
    let smartUrlsById = _.reduce(
      smartUrls,
      (acc, smartUrl) => {
        acc[smartUrl.id] = smartUrl;
        return acc;
      },
      {}
    );
    smartUrlsById = state.byId.merge(smartUrlsById);
    return state.set('byId', smartUrlsById);
  });
  on(SmartUrlActions.removeSmartUrl, (state, { id }) => state.set('byId', _.omit(state.byId, id)));
}, initialState);

export default reducer;
